export const types = [
  'Input',
  'Date',
  'Radio',
  'Checkbox',
  'Upload',
  'Textarea',
  'Dropdown',
  'Breakline',
  'Default',
  'Disclaimer',
  'Map'
];

export const fieldTemplates = {
  "input": [
    {
      "type": "method",
      "fields": "method",
      "fieldOptions": [
        {"label": "Text", "value": "text"},
        {"label": "Number", "value": "number"},
        {"label": "Email", "value": "email"},
        {"label": "Password", "value": "password"}
      ]
    },
    {
      "type": "input",
      "fields": ["Name", "English Label", "Arabic Label", "Character Length", "English Placeholder", "Arabic Placeholder"]
    },
    {
      "type": "checkbox",
      "fields": ["Required", "Encrypt"]
    }
  ],
  "textarea": [
    {
      "type": "input",
      "fields": ["Name", "English Label", "Arabic Label", "Character Length", "English Placeholder", "Arabic Placeholder"]
    },
    {
      "type": "checkbox",
      "fields": ["Required"]
    }
  ],
  "date": [
    {
      "type": "input",
      "fields": ["Name", "English Label", "Arabic Label", "English Placeholder", "Arabic Placeholder"]
    },
    {
      "type": "checkbox",
      "fields": ["Required"]
    }
  ],
  "upload": [
    {
      "type": "input",
      "fields": ["Name", "English Label", "Arabic Label", "English Placeholder", "Arabic Placeholder"]
    },
    {
      "type": "checkbox",
      "fields": ["Required", "Document Vault", "Multiple"]
    },
    {
      "type": "input",
      "fields": ["Limit"]
    },
    {
      "type": "category",
      "fields": ["category"]
    },
  ],
  "checkbox": [
    {
      "type": "input",
      "fields": ["Name", "English Label", "Arabic Label"]
    },
    {
      "type": "options",
      "fields": ["Option Name"]
    },
    {
      "type": "title",
      "fields": ["Options"]
    },
    {
      "type": "checkbox",
      "fields": ["Required"]
    }
  ],
  "radio": [
    {
      "type": "input",
      "fields": ["Name", "English Label", "Arabic Label"]
    },
    {
      "type": "options",
      "fields": ["Option Name"]
    },
    {
      "type": "title",
      "fields": ["Options"]
    },
    {
      "type": "checkbox",
      "fields": ["Required", "Dynamic"]
    }
  ],
  "dropdown": [
    {
      "type": "input",
      "fields": ["Name", "English Label", "Arabic Label", "English Placeholder", "Arabic Placeholder"]
    },
    {
      "type": "options",
      "fields": ["Option Name"]
    },
    {
      "type": "title",
      "fields": ["Options"]
    },
    {
      "type": "checkbox",
      "fields": ["Required", "Dynamic"]
    }
  ],
  "breakline": [
    {
      "type": "input",
      "fields": ["Note"]
    }
  ],
  "default": [
    {
      "type": "checkbox",
      "fields": ["Reference name", "Registered information", "ADRO Submission"]
    }
  ],
  "disclaimer": [
    {
      "type": "input",
      "fields": ["Name", "English Label", "Arabic Label"]
    }
  ],
  "map": [
    {
      "type": "input",
      "fields": ["Name", "English Label", "Arabic Label", "English Placeholder", "Arabic Placeholder"]
    },
    {
      "type": "checkbox",
      "fields": ["Required"]
    }
  ],
};

export const categories = [
  {"label": "Passport", "arabiclabel": "جواز سفر", "value": "Passport"},
  {"label": "Visa", "arabiclabel": "تأشيرة", "value": "Visa"},
];

export const serviceCards = [
  {label: 'Service Description', value: 'Service Description'},
  {label: 'Required Documents', value: 'Required Documents'},
  {label: 'Service Policies', value: 'Service Policies'},
  {label: 'Service Fees', value: 'Service Fees'},
  {label: 'Customer Journey Steps', value: 'Customer Journey Steps'}
];

export const arabicServiceCards = [
  {label: 'وصف الخدمة', value: 'Service Description'},
  {label: 'ملفات مطلوبة', value: 'Required Documents'},
  {label: 'سياسات الخدمة', value: 'Service Policies'},
  {label: 'رسوم الخدمة', value: 'Service Fees'},
  {label: 'خطوات رحلة العميل', value: 'Customer Journey Steps'}
];

export const langOptions = [
  {label: 'English', value: 'en'},
  {label: 'Arabic', value: 'ar'}
];

export const defaultFields = {
  referenceNameInput: {
    arabiclabel: "اسم مقدم الطلب",
    arabicplaceholder: "",
    characterlength: "50",
    encrypt: false,
    englishlabel: "Reference Name",
    englishplaceholder: "",
    method: "text",
    name: "ReferenceName",
    required: false,
    type: "input",
    defaultField: true
  },
  userInfoCheckbox: {
    arabiclabel: "المعلومات المسجلة",
    arabicplaceholder: "",
    encrypt: false,
    englishlabel: "Registered information",
    englishplaceholder: "",
    name: "UserInfo",
    required: false,
    type: "checkbox",
    defaultField: true
  },
  userAdroCheckbox: {
    arabiclabel: "سبق وقدمت طلب ترشيح عبر مكتب أبوظبي للمقيمين",
    arabicplaceholder: "",
    encrypt: false,
    englishlabel: "Already Submitted Nomination through ADRO",
    englishplaceholder: "",
    name: "ADROSubmission",
    required: false,
    type: "checkbox",
    defaultField: true
  },
  userInfoEmailInput: {
    arabiclabel: "البريد الإلكتروني",
    arabicplaceholder: "",
    characterlength: "50",
    encrypt: false,
    englishlabel: "E-mail",
    englishplaceholder: "",
    method: "text",
    name: "defaultUserInfoEmail",
    required: false,
    type: "input",
    defaultField: true
  },
  userInfoPhoneNumberInput: {
    arabiclabel: "رقم التواصل",
    arabicplaceholder: "",
    characterlength: "15",
    encrypt: false,
    englishlabel: "Contact Number",
    englishplaceholder: "",
    method: "number",
    name: "defaultUserInfoPhoneNumber",
    required: false,
    type: "input",
    defaultField: true
  },
  userInfoBreakLine: {
    required: false,
    type: "breakline",
    defaultField: true
  }
};